import request from "@/utils/request";

/* 登录 */
export function loginDo(params) {
  return request({
    url: `/api/login`,
    method: "post",
    data: params,
  });
}

// 注册
export function registerDo(params) {
  return request({
    url: `/api/login/phone`,
    method: "post",
    data: params,
  });
}

// 获取班级和部门
export function loadShoe(params) {
  return request({
    url: `/api/user/classAndDept`,
    method: "get",
    data: params,
  });
}

// 意见反馈
export function addFeedback(params) {
  return request({
    url: `/api/feedback`,
    method: "post",
    data: params,
  });
}
// 通知公告
export function loadNotic(params) {
  return request({
    url: `/api/notice?pageNum=${params.pageNum}&pageSize=${params.pageSize}`,
    method: "get",
    data: params,
  });
}
// 通知公告详情
export function loadNoticDetail(params) {
  return request({
    url: `/api/notice/${params.id}`,
    method: "get",
    data: params,
  });
}

// 获取我的考试
export function loadMyExamination(params) {
  return request({
    url: `/api/examination/examList?status=${params.status}&pageNum=${params.pageNum}&pageSize=${params.pageSize}`,
    method: "get",
    data: params,
  });
}
// 更新用户信息
export function userUpdate(params) {
  return request({
    url: `/api/user/update`,
    method: "post",
    data: params,
  });
}

// 获取用户信息
export function getUserInfo(params) {
  return request({
    url: `/api/user/info`,
    method: "get",
    data: params,
  });
}

// 获取用户培训记录
export function viewRecord(params) {
  return request({
    url: `/api/user/viewRecord?pageNum=${params.pageNum}&pageSize=${params.pageSize}`,
    method: "get",
    data: params,
  });
}

// 通用参数
export function commonParam(params) {
  return request({
    url: `/api/common/param`,
    method: "get",
    data: params,
  });
}

// 查询协议
export function commonClause(params) {
  return request({
    url: `/api/clause?type=${params.type}`,
    method: "get",
    data: params,
  });
}

// 修改密码 ddsb
export function changePwd(params) {
  return request({
    url: `/api/user/password`,
    method: "post",
    data: params,
  });
}

// 字典信息
export function getDict(params) {
  return request({
    url: `/api/common/dict`,
    method: "get",
    data: params,
  });
}

